import React, {useEffect, useRef} from 'react';
import { useLocation } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";

const Page = ({ children }) => {
  const ref = useRef(null);
  const footerRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const onLogo = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo(0, 0);
    }
  }

  const onContacts = (e) => {
    e.preventDefault();
    const target = footerRef?.current;
    if (target) {
      window.scrollTo({top: target?.offsetTop});
    }
  }

  return (
    <div ref={ref} >
      <Header onLogo={onLogo} onContacts={onContacts} />
      { children }
      <Footer ref={footerRef} />
    </div>
  );
};

export default Page;